export default "__VITE_ASSET__BSHVaEyb__"